// The Smart Vision Academy landing page is delivered as a self-contained
// public/index.html (vanilla HTML / CSS / JS as specified in the brief).
// React renders nothing here so the static page owns the full DOM.
// (No JSX is returned, so the React import is intentionally omitted —
// React 17+ JSX transform also makes it unnecessary even when JSX is used.)

export default function App() {
  return null;
}
